import request from "./../utils/request";

export async function getProductExtraList(payload) {
  return request.get("ProductExtra/List", {
    params: {
      extraId: payload.extra ? payload.extra.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      isGlobal: payload.isGlobal,
      minPrice: payload.price && payload.price.min ? payload.price.min : null,
      maxPrice: payload.price && payload.price.max ? payload.price.max : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.min ? payload.cost.max : null,
      originId: payload.extraOrigin ? payload.extraOrigin.id : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
};
export async function createNewProductExtra(newProductExtra) {
  return request.post("ProductExtra/Create", newProductExtra);
}
export async function updateProductExtra(productExtra) {
  return request.post("ProductExtra/Update", productExtra);
}
export async function deleteProductExtra(id) {
  return request.delete('ProductExtra/Delete?id=' + id);
}
